<script>
  export let page;
  import Icon from './Icon.svelte';
</script>

<div class="text-brand-blue flex flex-col justify-between">
  <a href="{page.link}" aria-label="Learn more - {page.title}">
    <div class="w-full aspect-w-3 aspect-h-2 mb-2">
      <img src="{page.image_link.replace(/_compact\./, '.')}&width=750" alt="" class="w-full h-full">
    </div>

    {#if page.title}
      <p class="h3 mb-2 font-normal">
        {page.title}
      </p>
    {/if}

    {#if page.description}
      <p class="b2 mb-2.5">
        {page.description}
      </p>
    {/if}
    
    <p class="btn btn--text group">
      <span>Learn More</span>

      <span class="btn--icon group-hover:translate-x-0.5">
        <Icon icon="long-arrow-right" h={12} w={12} />
      </span>
    </p>
  </a>
</div>